
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
function PlanDetails() {
    const [rowsData, setRowsData] = useState([]);
    const [sortConfig, setSortConfig] = useState({
        key: "name",
        direction: "ascending",
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(3);
    const [searchQuery, setSearchQuery] = useState(""); // New state for search query

    useEffect(() => {
        const fetchData = async () => {
            const data = [
                {
                    "Sl_No": "4",
                    "Status": "D",

                    "Name": "chennai",
                    "Account_No": "",
                    "Code": "AS3761",
                    "STB_No": "76544534563",
                    "D_No": "3",
                    "Flat_Name": "dfhg",
                    "Street": "1st MAIN RD, B.NAGAR",
                    "Mobile_No": "5464576587",
                    "Pay_Status": "free",
                    "Plan_Amount": "0",
                    "Paid_Amount": "0",

                    "Staff_Code": "TCCL CLASSIC SD",
                    "Network": "25-Oct-19",

                    "Collection_Staff": "UGF",

                },

            ];
            setRowsData(data);
        };

        fetchData();
    }, []);

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }

        const sortedData = [...rowsData].sort((a, b) => {
            if (a[key] < b[key]) {
                return direction === "ascending" ? -1 : 1;
            }
            if (a[key] > b[key]) {
                return direction === "ascending" ? 1 : -1;
            }
            return 0;
        });

        setRowsData(sortedData);
        setSortConfig({ key, direction });
    };

    const downloadCSV = () => {
        const headers = [
            "Sl_No", "Status", "Edit", "Select", "Pay", "Name", "Account_No", "Code", "STB_No",
            "D_No", "Flat_Name", "Street", "Mobile_No", "Pay_Status", "Plan_Amount", "Paid_Amount",
            "Paid_Date", "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
            "Staff_Code", "Network", "Paid_Time", "Packages", "History", "Location", "Collection_Staff", "Delete"
        ];
        const csvRows = [];
        csvRows.push(headers.join(","));
        rowsData.forEach(row => {
            csvRows.push([row.Sl_No, row.Status, row.Edit, row.Select, row.Pay, row.Name, row.Account_No,
            row.Code, row.STB_No, row.D_No, row.Flat_Name, row.Street, row.Mobile_No,
            row.Pay_Status, row.Plan_Amount, row.Paid_Amount, row.Paid_Date, row.Balance_Amount,
            row.Discount_Amount, row.Advance_Amount, row.Pending_Amount, row.Staff_Code, row.Network,
            row.Paid_Time, row.Packages, row.History, row.Location, row.Collection_Staff].join(","));
        });

        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rowsData.slice(indexOfFirstRow, indexOfLastRow);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(rowsData.length / rowsPerPage);

    // Filter rows based on search query across all columns
    const filteredRows = currentRows.filter((row) =>
        Object.values(row).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase()) // Ensure value is converted to string
        )
    );

    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4">PLAN DETAILS</div>
                </div>
                <hr />
                <div className="mt-3 mb-2 mb-lg-5 mx-lg-5">
                    <div className="card info-box border-0 px-1">

                        <Link to="/home">

                            <div className="d-flex justify-content-end py-0 pt-lg-4 mt-lg-2 pt-2">
                                <input type="submit" className="btn border-0 bg-gradient-info filterBtn text-light h-75 pb-3 pb-lg-1 w-25" value="Add Plan Amount" />
                            </div>
                        </Link>

                    </div>
                </div>


                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            {/* Header Title */}
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            {/* Actions */}
                            <div className="col-lg-8 mt-1">
                                <span>
                                    <div className="row w-auto">
                                        {/* Search Bar */}
                                        <div className="col-11 col-lg-6">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control text-navy bg-light border-0 px-1 py-0"
                                                    placeholder="Search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    style={{ borderRadius: "5px 0 0 5px" }}
                                                />
                                                <span
                                                    className="input-group-text bg-light text-navy border-0 px-2"
                                                    id="basic-addon1"
                                                    style={{ borderRadius: "0 5px 5px 0" }}
                                                >
                                                    <i className="fas fa-search" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                            <div className="d-flex justify-content-end">
                                                <div className=" btn-group">
                                                    <button
                                                        onClick={downloadCSV}
                                                        className="btn btn-dark border-right px-lg-3 px-5"
                                                    >
                                                        <i className="fas fa-download" /> Download
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>


                    <div className="card-body p-0">
                        <table id="myTable" className="table table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    {/* Table headers with sorting functionality */}
                                    <th onClick={() => handleSort("Sl_No")}>{sortConfig.key === "Sl_No" && (sortConfig.direction === "ascending" ? " ↑" : " ↓")}Sl_No     </th>

                                    <th>Package</th>

                                    <th>Assigned Date</th>

                                    <th>Extra Amount</th>

                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index} style={{ backgroundColor: row.Pay === "unpaid" ? "#ffd9de" : "#cffcd0" }}>
                                            <td>{row.Sl_No}</td>
                                            <td>{row.Name}</td>
                                            <td>{row.Name}</td>
                                            <td>{row.Total}</td>
                                          
                                            <td>
                                                <div className="d-flex justify-content-center">
                                                    <button className="btn btn-outline-danger"><i className="fas fa-trash"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <div className="pagination btn-group">
                        {/* Previous Button */}
                        <button
                            className="btn bg-secondary border-right"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{ opacity: currentPage === 1 ? 0.6 : 1 }}
                        >
                            <i className="fas fa-backward"></i>
                        </button>
                        {/* First Page Button */}
                        <button
                            onClick={() => paginate(1)}
                            className={`btn ${currentPage === 1 ? "bg-navy" : "btn-secondary"} border-left`}
                        >
                            1
                        </button>
                        {/* Ellipsis Before Current Range */}
                        {currentPage > 3 && <span className="mx-1">...</span>}
                        {/* Middle Page Buttons */}
                        {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                            .filter((page) => page > 1 && page < totalPages)
                            .map((page) => (
                                <button
                                    key={page}
                                    onClick={() => paginate(page)}
                                    className={`btn ${currentPage === page ? "bg-navy" : "btn-outline-secondary"}`}
                                    style={{ fontWeight: currentPage === page ? "bold" : "normal" }}
                                >
                                    {page}
                                </button>
                            ))}
                        {/* Ellipsis After Current Range */}
                        {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                        {/* Last Page Button */}
                        {totalPages > 1 && (
                            <button
                                onClick={() => paginate(totalPages)}
                                className={`btn ${currentPage === totalPages ? "bg-navy" : "btn-secondary"} border-right`}
                            >
                                {totalPages}
                            </button>
                        )}
                        {/* Next Button */}
                        <button
                            className="btn btn-secondary  border-left"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{ opacity: currentPage === totalPages ? 0.6 : 1 }}
                        >
                            <i className="fas fa-forward"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlanDetails;
